import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/settings/payout';

export const getPayoutSettingsPath = () => {
  return getRelativePath(BASE_PATH);
};
